
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 1.579C20 .707 19.254 0 18.333 0H1.667C.747 0 0 .707 0 1.579v11.842C0 14.293.746 15 1.667 15h16.666c.92 0 1.667-.707 1.667-1.579V1.58zm-2 11.054c0 .203-.18.367-.4.367H2.4c-.22 0-.4-.164-.4-.367V2.367C2 2.164 2.18 2 2.4 2h15.2c.22 0 .4.164.4.367v10.266zM10 7.5c0 .387.33.7.737.7h4.699c.407 0 .737-.313.737-.7 0-.387-.33-.7-.737-.7h-4.7c-.406 0-.736.313-.736.7zm0 2.8c0 .387.33.7.737.7H13.3c.407 0 .737-.313.737-.7 0-.387-.33-.7-.737-.7h-2.563c-.407 0-.737.313-.737.7zm5.65-4.9c.406 0 .736-.313.736-.7 0-.387-.33-.7-.737-.7h-4.912c-.407 0-.737.313-.737.7 0 .387.33.7.737.7h4.912zM6.065 7.5c1.018 0 1.842-.783 1.842-1.75 0-.966-.824-1.75-1.842-1.75-1.017 0-1.842.784-1.842 1.75 0 .967.825 1.75 1.842 1.75zm-2.6 3.5h5.201a.468.468 0 00.385-.19.42.42 0 00.05-.409c-.483-1.2-1.684-2.002-3.036-2.026-1.351.025-2.552.827-3.034 2.027a.42.42 0 00.05.409c.086.12.23.19.384.189z"}})])
          )
        }
      }
    